(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-countdown-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var daysEl = document.getElementById('wm-countdown-days');
    var hoursEl = document.getElementById('wm-countdown-hours');
    var minutesEl = document.getElementById('wm-countdown-minutes');
    var secondsEl = document.getElementById('wm-countdown-seconds');

    if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

    function pad(n) { return String(n).padStart(2, '0'); }

    // ✅ ФИКСИРАНИ ДАТИ (не се ресетва от никого)
    // Europe/Sofia през декември е UTC+2
    // 16 Dec 00:00 Sofia = 19 Dec 22:00 UTC
    // 19 Dec 00:00 Sofia = 25 Dec 22:00 UTC
    var START_UTC = Date.UTC(2025, 11, 19, 22, 0, 0); // 2025-12-19 22:00:00Z
    var END_UTC   = Date.UTC(2025, 11, 25, 22, 0, 0); // 2025-12-25 22:00:00Z

    function setAllZero() {
      daysEl.textContent = '00';
      hoursEl.textContent = '00';
      minutesEl.textContent = '00';
      secondsEl.textContent = '00';
    }

    function tick() {
      var now = Date.now();

      // Ако още не е започнало — показваме оставащото до старта (по желание).
      // Ако НЕ го искаш, кажи и ще го направя да показва 03d от самото начало.
      if (now < START_UTC) {
        var diffToStart = START_UTC - now;
        var totalS = Math.max(0, Math.floor(diffToStart / 1000));

        var d = Math.floor(totalS / 86400);
        var h = Math.floor((totalS % 86400) / 3600);
        var m = Math.floor((totalS % 3600) / 60);
        var s = totalS % 60;

        daysEl.textContent = pad(d);
        hoursEl.textContent = pad(h);
        minutesEl.textContent = pad(m);
        secondsEl.textContent = pad(s);
        return;
      }

      // Ако е свършило — спира на 00:00:00 и край.
      if (now >= END_UTC) {
        setAllZero();
        return;
      }

      // В периода 13 → 16 декември: броим до края
      var diff = END_UTC - now;
      var totalSeconds = Math.max(0, Math.floor(diff / 1000));

      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      daysEl.textContent = pad(days);
      hoursEl.textContent = pad(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);
    }

    tick();
    setInterval(tick, 1000);
  })();

  } catch(e) { console.error(e); }
})();
})();
